import React from 'react';
import {
    useLocalizedPriceFormatter,
    useLocalizedPriceFormatterRoundingUp
} from 'tradera/localization/use-localized-price-formatter';

type LocalizedPriceProps = {
    className?: string;
    price?: number;
    renderZero?: boolean;
    roundUp?: boolean;
};

const LocalizedPrice = ({
    className,
    price,
    renderZero,
    roundUp
}: LocalizedPriceProps) => {
    const localizedPriceFormatter = useLocalizedPriceFormatter();
    const localizedPriceFormatterRoundingUp =
        useLocalizedPriceFormatterRoundingUp();

    if (!price && !(renderZero && price === 0)) {
        return null;
    }

    const formattedPrice = roundUp
        ? localizedPriceFormatterRoundingUp(price)
        : localizedPriceFormatter(price);

    return formattedPrice ? (
        <span className={className}>{formattedPrice}</span>
    ) : null;
};

export default LocalizedPrice;
